import { Font } from '@react-pdf/renderer';
import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { DevelopmentTimelineTable } from 'PDF/components/DevelopmentTimeline/DevelopmentTimelineTable';
import { PDFPage } from 'PDF/components/Page';
import { SubChapterHeading } from 'PDF/components/SubChapterHeading';
import { PDF_SECTIONS } from 'PDF/constants/sections';
import { Noto } from 'PDF/fonts';
import { getSectionInfo } from 'PDF/helpers/sections';
import { ImplementationPlanSectionAvailability } from 'PDF/types/pdfSections';

import { IImplementationPlanPdfData } from './type';
import { SectionCoverPagePdf } from '../SectionCoverPage';

Font.getRegisteredFonts();
Font.register(Noto);
 
export interface IImplementationPlanPdfProps {
  data: IImplementationPlanPdfData;
  sectionPicture?: string;
  isStandardOrLightTariff: boolean
  isExamplePage: boolean;
}

export const ImplementationPlanPdf = (
  props: IImplementationPlanPdfProps & {
    availability: ImplementationPlanSectionAvailability;
    isPreviewMode?: boolean;
    sectionNumber: string;
  },
) => {
  const { data, sectionPicture, availability, isPreviewMode = false, sectionNumber, isStandardOrLightTariff, isExamplePage } = props;
  const { sectionHeading } = getSectionInfo(BUSINESS_PLAN_TYPES.FOR_BANK, PDF_SECTIONS.IMPLEMENTATION_PLAN, isExamplePage);
  const isSectionEmpty = !availability.wholePage;
  const isCoverPageEmpty = isSectionEmpty && isPreviewMode;

  if (!data) {
    return (
      <SectionCoverPagePdf
        header={sectionHeading}
        sectionNumber={sectionNumber}
        sectionId="implementationPlan"
        background={sectionPicture ?? ''}
        highlightSettings={{ position: 1, variant: 'after' }}
        subChapterNames={[]}
        isEmpty={isCoverPageEmpty}
        isStandardOrLightTariff={isStandardOrLightTariff}
        isExamplePage={isExamplePage}
      />
    );
  }

  const { stages } = data;

  return (
    <>
      {(!isSectionEmpty || isCoverPageEmpty) && (
        <SectionCoverPagePdf
          header={sectionHeading}
          sectionNumber={sectionNumber}
          sectionId="implementationPlan"
          background={sectionPicture ?? ''}
          highlightSettings={{ position: 1, variant: 'after' }}
          subChapterNames={[]}
          isEmpty={isCoverPageEmpty}
          isStandardOrLightTariff={isStandardOrLightTariff}
          isExamplePage={isExamplePage}
        />
      )}
      {!isSectionEmpty && (
        <PDFPage
          shouldShowHeaderAndFooter
          sectionNumber={sectionNumber}
          sectionTitle={sectionHeading}
          withEmptySpaceImage
          isStandardOrLightTariff={isStandardOrLightTariff}
        >
          <SubChapterHeading id="implementationPlan.empty" heading="" />
          {stages.length > 0 && <DevelopmentTimelineTable items={stages} isExamplePage={isExamplePage}/>}
        </PDFPage>
      )}
    </>
  );
};
